<template>
  <div class="product-detail-page column-me" :class="{'mobile-mode': isMobile}">
    <!-- 顶部彩色条 - 动画展开 -->
    <div class="row-me row-center color-bar-top" ref="topBar">
      <div class="flex1 h10 color-bar-left" style="background: #EB8063;"></div>
      <div class="flex1 h10 color-bar-right" style="background: #B2C2E3;"></div>
    </div>
    <!-- Banner区域 - 轮播图 -->
    <div class="banner-section animate-fade-in" ref="bannerSection">
      <el-carousel :interval="3000" arrow="hover">
        <el-carousel-item v-for="(item, index) in bannerImages" :key="index">
          <div class="carousel-item-wrapper">
            <el-image :src="item" :preview-src-list="bannerImages" fit="contain" class="carousel-image"
                      hide-on-click-modal preview-teleported :initial-index="index">
            </el-image>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="column-me row-center pTB50 content-wrapper">
      <div class="w1000 column-me row-center detail-content">
        <div class="font48 colorBlue font-db product-title alignC animate-slide-up"
             style="animation-delay: 0.1s;">{{ productData.categoryName }}
        </div>
        <div class="font48 mT10 font-db product-subtitle alignC animate-slide-up"
             style="color: #454F5E; animation-delay: 0.2s;">{{ productData.title }}
        </div>
        <div class="font18 mT20 font-m product-code animate-slide-up"
             style="color: #454F5E; animation-delay: 0.3s;">{{ productData.regNumber }}
        </div>
        <div class="mT50 font-n product-desc rich-text animate-fade-in-up"
             style="animation-delay: 0.4s;" v-if="productData.content"
             v-html="this.$method.formatRichText(productData.content)"></div>
        <div class="row-me center-all mT50 animate-scale-in" style="animation-delay: 0.5s;">
          <div class="btn-p pointer row-me center-all" @click="clickProduct">
            <div class="font24 font-n">{{ $t('productDetail.productCenter') }}</div>
            <img src="../../assets/img/home/go.png" class="img30 objScaleDown mL10" draggable="false">
          </div>
        </div>
      </div>
    </div>
    <!-- 底部彩色条 - 动画展开 -->
    <div class="row-me row-center color-bar-bottom" ref="bottomBar">
      <div class="flex1 h10 color-bar-left" style="background: #EB8063;"></div>
      <div class="flex1 h10 color-bar-right" style="background: #B2C2E3;"></div>
    </div>
  </div>
</template>

<script>
import {deviceState} from "@/utils/device";
import {getProductDetail, parseImages} from "@/http/api";
import bus from "@/assets/js/bus";

export default {
  data() {
    return {
      deviceState,
      productId: null,
      // 产品详情数据
      productData: {
        title: '',
        categoryName: '',
        regNumber: '',
        content: '',
        images: []
      }
    }
  },
  computed: {
    isMobile() {
      return this.deviceState.isMobile
    },
    // 轮播图列表 - 完全从API获取
    bannerImages() {
      return this.productData.images || []
    }
  },
  created() {
    this.productId = this.$route.query.id
    if (this.productId) {
      this.loadProductDetail()
    }
  },
  mounted() {
    // 监听语言切换事件
    bus.$on('language-changed', this.onLanguageChanged)
    // 延迟触发入场动画，确保浏览器先渲染初始状态
    this.$nextTick(() => {
      // 使用 requestAnimationFrame 确保 DOM 已渲染
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.triggerEntranceAnimation()
        })
      })
    })
  },
  beforeUnmount() {
    bus.$off('language-changed', this.onLanguageChanged)
  },
  methods: {
    // 语言切换时重新加载数据
    onLanguageChanged() {
      if (this.productId) {
        this.loadProductDetail()
      }
    },
    // 加载产品详情
    async loadProductDetail() {
      try {
        const res = await getProductDetail(this.productId)
        if (res && res.code === 200 && res.data) {
          this.productData = {
            id: res.data.id,
            categoryId: res.data.categoryId,
            categoryName: res.data.categoryName || '',
            title: res.data.title || '',
            regNumber: res.data.regNumber || '',
            content: res.data.content || '',
            images: parseImages(res.data.images)
          }
          // 数据加载完成后触发内容动画
          this.$nextTick(() => {
            this.triggerContentAnimation()
          })
        }
      } catch (error) {
        console.error('加载产品详情失败:', error)
      }
    },
    // 触发入场动画
    triggerEntranceAnimation() {
      // 顶部彩色条动画
      if (this.$refs.topBar) {
        const bars = this.$refs.topBar.querySelectorAll('.color-bar-left, .color-bar-right')
        bars.forEach(bar => {
          bar.classList.add('animate-in')
        })
      }
      // Banner区域动画
      if (this.$refs.bannerSection) {
        this.$refs.bannerSection.classList.add('animate-in')
      }
    },
    // 触发内容动画
    triggerContentAnimation() {
      const animateElements = this.$el.querySelectorAll('.animate-slide-up, .animate-fade-in-up, .animate-scale-in')
      animateElements.forEach(el => {
        el.classList.add('animate-in')
      })
      // 底部彩色条动画
      if (this.$refs.bottomBar) {
        const bars = this.$refs.bottomBar.querySelectorAll('.color-bar-left, .color-bar-right')
        bars.forEach(bar => {
          bar.classList.add('animate-in')
        })
      }
    },
    clickProduct() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail-page {
  width: 100%;
  background: linear-gradient(347deg, #F9F9F9 27.61%, #F5F7F8 40%, #ECF3F8 60%, #c5e2f4 100%);

  .btn-p {
    padding: 0 20px;
    height: 46px;
    line-height: 46px;
    background: #EDEDF1;
    border-radius: 23px 23px 23px 23px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(-1px);
    }
  }
}

// ==================== 入场动画样式 ====================

// 顶部/底部彩色条动画
.color-bar-left {
  transform: scaleX(0);
  transform-origin: right center;
  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &.animate-in {
    transform: scaleX(1);
  }
}

.color-bar-right {
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s;

  &.animate-in {
    transform: scaleX(1);
  }
}

// Banner淡入动画
.animate-fade-in {
  opacity: 0;
  transition: opacity 0.8s ease-out 0.2s;

  &.animate-in {
    opacity: 1;
  }
}

// 标题从下往上滑入
.animate-slide-up {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 内容淡入上移
.animate-fade-in-up {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
}

// 按钮缩放弹入
.animate-scale-in {
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.5s ease-out, transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);

  &.animate-in {
    opacity: 1;
    transform: scale(1);
  }
}

// Banner样式 - 轮播图
.banner-section {
  width: 100%;
  height: 800px;
  position: relative;
  overflow: hidden;

  .carousel-item-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .carousel-image {
    max-width: 70%;
    object-fit: contain;
    animation: zoomIn 0.8s ease-out;
    overflow: auto;

    :deep(.el-image__inner) {
      max-height: 500px;
    }
  }
}

@keyframes zoomIn {
  from {
    transform: scale(1.1);
    opacity: 0.8;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

// 自定义轮播图样式
:deep(.el-carousel) {
  height: 800px;

  .el-carousel__container {
    height: 800px;
  }

  .el-carousel__arrow {
    background: rgba(234, 128, 99, 0.9);
    width: 50px;
    height: 50px;
    font-size: 22px;
    transition: all 0.3s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:hover {
      background: #EA8063;
      transform: scale(1.15);
      box-shadow: 0 6px 20px rgba(234, 128, 99, 0.5);
    }
  }

  .el-carousel__arrow--left {
    left: 200px;
  }

  .el-carousel__arrow--right {
    right: 200px;
  }

  .el-carousel__indicators {
    bottom: 30px;

    .el-carousel__indicator {
      .el-carousel__button {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: #E8EDF7;
        transition: all 0.3s;
      }

      &.is-active {
        .el-carousel__button {
          background: #EB8063;
        }
      }

      &:hover {
        .el-carousel__button {
          background: #EB8063;
          opacity: 0.8;
        }
      }
    }
  }
}

.product-desc {
  line-height: 1.8;
  color: #454F5E;
  text-align: justify;
  word-break: break-word;

  :deep(p) {
    margin: 0;
    min-height: 1em;
  }

  :deep(img) {
    max-width: 100%;
  }
}

// ==================== 手机端适配样式 ====================
.product-detail-page.mobile-mode {
  padding-top: 100px;
  // 轮播图适配
  .banner-section {
    height: fit-content;

    .carousel-item-wrapper {
      padding: 20px;
    }

    .carousel-image {
      max-width: 90%;
      max-height: 90%;
    }
  }

  :deep(.el-carousel) {
    height: 500px !important;

    .el-carousel__container {
      height: 500px !important;
    }

    .el-carousel__arrow {
      width: 35px;
      height: 35px;
      font-size: 16px;
    }

    .el-carousel__arrow--left {
      left: 15px;
    }

    .el-carousel__arrow--right {
      right: 15px;
    }

    .el-carousel__indicators {
      bottom: 15px;

      .el-carousel__indicator {
        .el-carousel__button {
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  // 内容区域适配
  .content-wrapper {
    padding: 60px !important;
  }

  .detail-content {
    width: 100% !important;
    text-align: center;

    .product-title {
      width: 100%;
      font-size: 30px !important;
    }

    .product-subtitle {
      width: 100%;
      font-size: 32px !important;
      margin-top: 10px !important;
    }

    .product-code {
      width: 100%;
      font-size: 11px !important;
      margin-top: 10px !important;
    }

    .product-desc {
      width: 100%;
      font-size: 14px;
      line-height: 1.8;
      text-align: justify;
      margin-top: 35px !important;
    }

    .btn-p {
      margin-top: 30px !important;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;

      .font24 {
        font-size: 24px !important;
      }

      .img30 {
        width: 30px !important;
        height: 30px !important;
        margin-left: 8px !important;
        object-fit: cover;
      }
    }
  }
}
</style>


